import React, { useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SNETButton, AlertBox, alertTypes } from "shared/dist/components";
import { checkIfKnownError } from "shared/dist/utils/error";
import validator from "shared/dist/utils/validator";
import ValidationError from "shared/dist/utils/validationError";

import { profileIdentityDetails } from "./content";
import MMAddress from "./MMAddress";
import { onboardingRoutes } from "../../Routes";
import { inviteMembersActions } from "../../../../Services/Redux/actionCreators";
import { inviteeValidationConstraints } from "./validationConstraints";

import classes from "./Invitee.module.css";
import { useNavigateTo } from "../../../../GlobalRouter/hook/NavigateTo";
import FormActions from "../../../../Components/PageFormComponents/FormActions";
import FormContentCard from "../../../../Components/PageFormComponents/FormContentCard";

const Invitee = () => {
    const inviteCode = useSelector((state) => state.user.inviteCode);
    const dispatch = useDispatch();
    const navigateTo = useNavigateTo();

    const [address, setAddress] = useState("");
    const [alert, setAlert] = useState({});

    const handleCancel = () => {
        navigateTo.onboarding(onboardingRoutes.SINGULARITY_ACCOUNT.path);
    };

    const handleNavigateBack = () => {
        navigateTo.onboarding(onboardingRoutes.ACCEPT_SERVICE_AGREEMENT.path);
    };

    const handleFinish = async () => {
        try {
            const isNotValid = validator({ address }, inviteeValidationConstraints);
            if (isNotValid) {
                throw new ValidationError(isNotValid[0]);
            }
            const payload = {
                invite_code: inviteCode,
                wallet_address: address,
            };
            const org = await dispatch(
                inviteMembersActions.acceptInvitationAndGetLatestOrgStatus(payload)
            );
            if (org) {
                navigateTo.organizationStatus({ orgUuid: org.uuid });
            }
        } catch (error) {
            if (checkIfKnownError(error)) {
                return setAlert({ type: alertTypes.ERROR, message: error.message });
            }
            return setAlert({ type: alertTypes.ERROR, message: "something went wrong" });
        }
    };

    return (
        <Fragment>
            <FormContentCard
                title={profileIdentityDetails.title}
                description={profileIdentityDetails.description}
            >
                <div className={classes.mmAction}>
                    <MMAddress address={address} setAddress={setAddress} />
                    <AlertBox type={alert.type} message={alert.message} />
                </div>
            </FormContentCard>
            <FormActions>
                <SNETButton variant="outlined" children="cancel" onClick={handleCancel} />
                <SNETButton variant="outlined" children="back" onClick={handleNavigateBack} />
                <SNETButton
                    color="primary"
                    variant="contained"
                    children="finish"
                    disabled={!address}
                    onClick={handleFinish}
                />
            </FormActions>
        </Fragment>
    );
};

export default Invitee;
